import ZCard from './ZCard.vue'

export default ZCard
